import { activeOrgSelector } from 'redux/reducer/AuthenticationReducer';
import { axiosInstance } from 'utils/http';
import { cleanRoom } from 'utils/urlConstants';
import { showAlert } from 'redux/actions/AlertActions';
import { useDispatch, useSelector } from 'react-redux';
import { useMutation } from 'react-query';


export const useUpdateCleanRoom = () => {
  const dispatch = useDispatch();
  const { ID: orgId } = useSelector(activeOrgSelector);
  return useMutation(
    async (
      { crId, payload },
    ) => axiosInstance.put(cleanRoom(orgId).update(crId), payload),
    {
      onSuccess: () => {
        dispatch(showAlert({
          message: 'Successfully updated clean room',
          type: 'success',
        }));
      },
      onError: (err) => {
        dispatch(showAlert({
          message: err.response.data.message,
          type: 'error',
        }));
      },
    },
  );
};
